module.exports = __webpack_public_path__ + "static/media/data-slider-image-4.db40150c.png";